/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { color } from '../../../styles/Theme';

export const Container = styled.div`
	display: flex;
	align-items: center;
`;

export const ContainerCheck = styled.div`
	position: relative;
	width: ${(props) => props.widthCheck};
	height: ${(props) => props.widthCheck};
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

	input {
		display: none;
	}

	span {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: ${(props) => props.widthCheck};
		height: ${(props) => props.widthCheck};
		border-radius: ${(props) => (props.inputType === 'radio' ? '50%' : '15%')};
		border: ${(props) =>
			props.disabled
				? `1px solid ${color.interface.lightGray2}`
				: props.isError
				? `1px solid ${color.interface.red}`
				: !props.defaultCheckColor
				? `2px solid ${color.interface.gray}`
				: `1px solid ${color.interface.green}`};
		background-color: ${(props) =>
			props.disabled
				? color.interface.lightGray
				: props.isChecked && props.defaultCheckColor
				? color.interface.green
				: props.isChecked && !props.defaultCheckColor
				? color.interface.orange
				: 'transparent'};
	}

	img {
		position: absolute;
		width: 10px;
	}
`;

export const Box = styled.div`
	display: flex;

	> span {
		font-size: 0.813rem;
		font-weight: 400;
		padding-left: 5px;
	}

	text-transform: uppercase;
	.error-send {
		font-weight: 700;
		font-size: 0.625rem;
		color: ${color.interface.red};
		padding-left: 5px;
		height: 10px;
	}
`;
